import { Tooltip } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { IconClearFilters } from "../../../assets";
import { LMIconButton } from "../../../components/LMIconButton";
import { LMMultiSelect } from "../../../components/LMMultiSelect";
import { LMRangePicker } from "../../../components/LMRangePicker";
import { IOrdersListFilters } from "../types";
import { RangeValue } from "../../../components/LMRangePicker";
import { getOrderStatusesForFilter } from "../utils";
import { AppDispatch } from "../../../app/store";
import { actions } from "../slice";
import styles from "./OrderFilters.module.css";

interface Props {
  filters: IOrdersListFilters;
  onSearchLastChanged: (value: boolean) => void;
}

export const OrderFilters: FC<Props> = ({ filters, onSearchLastChanged }) => {
  const { t } = useTranslation("orders");
  const { t: tOrder } = useTranslation("order");
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch<AppDispatch>();

  const handleStatusesChange = (value: string[]) => {
    onSearchLastChanged(false);
    searchParams.set("statuses", value.join(","));
    setSearchParams(searchParams);
  };

  const handleDateChange = (values: RangeValue) => {
    onSearchLastChanged(false);
    if (!values) return;
    const start = values[0] as Date;
    const end = values[1] as Date;
    searchParams.set("start", start.toString());
    searchParams.set("end", end.toString());
    setSearchParams(searchParams);
  };

  const handleClearFilters = () => {
    onSearchLastChanged(false);
    dispatch(actions.clearDetails());
  };

  const disabledDate = (current: Date) => {
    return current > new Date();
  };

  return (
    <div className={styles.container}>
      <LMRangePicker
        value={[
          filters.dateFilter.start || null,
          filters.dateFilter.end || null,
        ]}
        size="large"
        onChange={handleDateChange}
        disabledDate={disabledDate}
      />
      <div className={styles.status}>
        <LMMultiSelect
          value={filters.statusFilter}
          onChange={handleStatusesChange}
          placeholder={t("statusPlaceholder")}
          items={getOrderStatusesForFilter().map((status) => ({
            name: tOrder(status),
            value: status,
          }))}
        />
      </div>
      <Tooltip placement="top" title={t("resetFilters")}>
        <LMIconButton color="white" onClick={handleClearFilters}>
          <IconClearFilters />
        </LMIconButton>
      </Tooltip>
    </div>
  );
};
